import { AdminAccordionSection } from "./AdminAccordionSection";
import { AdminPendingApprovalsBlock } from "./AdminPendingApprovalsBlock";
import { AdminRolePendingBlock } from "./AdminRolePendingBlock";
import { AdminActiveMembersBlock } from "./AdminActiveMembersBlock";
import { AdminInviteUserBlock } from "./AdminInviteUserBlock";

export function AdminPanelUsersModal(props: any) {
  // Layout: mobile (<lg) keeps the existing single-column stack of accordions.
  // Desktop (lg:+) is desktop-layout-pass Slice 2: left col-span-8 holds the
  // operational queues (Pending Approvals / Approved-Role-Pending / Active
  // Members) and right col-span-4 holds the Invite User form, sticky so it
  // stays visible while scrolling a long member list. Per
  // docs/planning/desktop_layout_pass.md §4.1.1 row 2.
  return (
    <div className="lg:grid lg:grid-cols-12 lg:gap-4 lg:items-start">
      <div className="space-y-4 lg:col-span-8">
      <AdminAccordionSection title="Pending Approvals" badge={props.pendingProfiles.length} badgeUrgent open={props.open.has("pending")} onToggle={() => props.toggle("pending")} highlight={props.pendingProfiles.length > 0}>
        <AdminPendingApprovalsBlock
          pendingProfiles={props.pendingProfiles}
          loading={props.loading}
          getRoleFor={props.getRoleFor}
          setRoleByUser={props.setRoleByUser}
          blockReasonByUser={props.blockReasonByUser}
          setBlockReasonByUser={props.setBlockReasonByUser}
          canDeleteUser={props.canPermanentlyDeleteUsers}
          canAssignManufacturingOrgRole={props.canAssignManufacturingOrgRole}
          onApproveAndAssign={(id) => void props.approveAndAssign(id)}
          onBlock={(id, name) => void props.block(id, name)}
          onDeleteUser={(id, name) => void props.deleteUser(id, name)}
        />
      </AdminAccordionSection>
      <AdminAccordionSection title="Approved - Role Pending" badge={props.approvedRolePending.length} badgeUrgent open={props.open.has("rolepending")} onToggle={() => props.toggle("rolepending")} highlight={props.approvedRolePending.length > 0}>
        <AdminRolePendingBlock
          approvedRolePending={props.approvedRolePending}
          rolesByUserId={props.rolesByUserId}
          loading={props.loading}
          getRoleFor={props.getRoleFor}
          setRoleByUser={props.setRoleByUser}
          blockReasonByUser={props.blockReasonByUser}
          setBlockReasonByUser={props.setBlockReasonByUser}
          canDeleteUser={props.canPermanentlyDeleteUsers}
          canAssignManufacturingOrgRole={props.canAssignManufacturingOrgRole}
          onAssignRole={(id) => void props.assignRole(id)}
          onBlock={(id, name) => void props.block(id, name)}
          onDeleteUser={(id, name) => void props.deleteUser(id, name)}
        />
      </AdminAccordionSection>
      <AdminAccordionSection title="Active Members" badge={props.activeMembers.length} open={props.open.has("members")} onToggle={() => props.toggle("members")}>
        <AdminActiveMembersBlock
          activeMembers={props.activeMembers}
          currentUserId={props.currentUserId}
          loading={props.loading}
          isPlatformAdmin={props.canPermanentlyDeleteUsers}
          canAssignManufacturingOrgRole={props.canAssignManufacturingOrgRole}
          collapsedMembers={props.collapsedMembers}
          toggleMember={props.toggleMember}
          platformRoleByUser={props.platformRoleByUser}
          memberPlatformRoleEdits={props.memberPlatformRoleEdits}
          setMemberPlatformRoleEdits={props.setMemberPlatformRoleEdits}
          memberLocations={props.memberLocations}
          addRoleByUser={props.addRoleByUser}
          setAddRoleByUser={props.setAddRoleByUser}
          addLocByUser={props.addLocByUser}
          setAddLocByUser={props.setAddLocByUser}
          memberPlants={props.memberPlants ?? {}}
          plantOptions={props.orgPlantOptions ?? []}
          addPlantByUser={props.addPlantByUser ?? {}}
          setAddPlantByUser={props.setAddPlantByUser}
          onAddUserPlant={(m, plantId) => void props.addUserPlant?.(m, plantId)}
          onRemoveUserPlant={(m, plantId) => void props.removeUserPlant?.(m, plantId)}
          onUpdateMemberPlatformRole={(m) => void props.updateMemberPlatformRole(m)}
          onBlockMember={(userId, name) => void props.block(userId, name)}
          onDeactivateMembership={(m) => void props.deactivateMembership(m)}
          onDeleteUser={(userId, name) => void props.deleteUser(userId, name)}
          onRemoveOrgRole={(m, r) => void props.removeOrgRole(m, r)}
          onAddOrgRole={(m, r) => void props.addOrgRole(m, r)}
          onAddUserLocation={(m, locId) => void props.addUserLocation(m, locId)}
          onRemoveUserLocation={(m, locId) => void props.removeUserLocation(m, locId)}
          onResendInvite={(m) => void props.resendInvite(m)}
          memberCapabilityByUser={props.memberCapabilityByUser ?? {}}
          onSetMemberAdsRunner={(m, value) => void props.setMemberAdsRunner(m, value)}
        />
        <div className="mt-3 rounded-lg border border-amber-200 bg-amber-50 p-3">
          <button type="button" onClick={() => props.setShowMergeUsers((v: boolean) => !v)} className="w-full flex items-center justify-between text-left">
            <span className="text-xs font-semibold text-amber-900">Merge duplicate app users</span>
            <span className="text-xs text-amber-800">{props.showMergeUsers ? "Hide" : "Show"}</span>
          </button>
          {props.showMergeUsers ? (
            <div className="mt-2 space-y-2">
              <p className="text-xs text-amber-800">Moves source user roles/directory links into target user, then deactivates the source profile.</p>
              <div className="grid grid-cols-1 md:grid-cols-2 gap-2">
                <select className="rounded-md border border-amber-300 px-2 py-1.5 text-xs bg-white" value={props.mergeSourceUserId} onChange={(e) => props.setMergeSourceUserId(e.target.value)} disabled={props.mergeBusy}>
                  <option value="">Source user (to merge from)</option>
                  {props.mergeUserOptions.map((opt: any) => <option key={opt.id} value={opt.id}>{opt.label}</option>)}
                </select>
                <select className="rounded-md border border-amber-300 px-2 py-1.5 text-xs bg-white" value={props.mergeTargetUserId} onChange={(e) => props.setMergeTargetUserId(e.target.value)} disabled={props.mergeBusy}>
                  <option value="">Target user (to keep)</option>
                  {props.mergeUserOptions.map((opt: any) => <option key={opt.id} value={opt.id}>{opt.label}</option>)}
                </select>
              </div>
              <button type="button" onClick={() => void props.mergeDuplicateUsers()} disabled={props.mergeBusy || !props.mergeSourceUserId || !props.mergeTargetUserId} className="px-3 py-1.5 rounded-lg bg-amber-700 text-white text-xs disabled:opacity-50">
                {props.mergeBusy ? "Merging..." : "Merge users"}
              </button>
            </div>
          ) : null}
        </div>
      </AdminAccordionSection>
      </div>
      <div className="lg:col-span-4 lg:sticky lg:top-4 mt-4 lg:mt-0">
        <AdminAccordionSection
          title="Invite User"
          headerFireflyTargetId="admin-invite-section"
          open={props.open.has("invite")}
          onToggle={() => props.toggle("invite")}
        >
          <AdminInviteUserBlock
            activeOrgName={props.activeOrgName}
            effectiveOrgId={props.effectiveOrgId}
            inviteEmail={props.inviteEmail}
            setInviteEmail={props.setInviteEmail}
            inviteRole={props.inviteRole}
            setInviteRole={props.setInviteRole}
            invitePlatformRole={props.invitePlatformRole}
            setInvitePlatformRole={props.setInvitePlatformRole}
            inviteLoading={props.inviteLoading}
            inviteMsg={props.inviteMsg}
            showPlatformRolePicker={props.auth.hasRole("platform_admin", "platform_dev")}
            canAssignManufacturingOrgRole={props.canAssignManufacturingOrgRole}
            onSubmitInvite={() => void props.submitInvite()}
          />
        </AdminAccordionSection>
      </div>
    </div>
  );
}
